import React from 'react';
import {
  Card,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import CardHeader from '@material-ui/core/CardHeader';
import { makeStyles } from '@material-ui/core/styles';
import {
  useTranslate,
  EditButton,
  DeleteButton,
  BooleanField
} from 'react-admin';
import PostFilter from '../../Components/PostFilter';

const useStyles = makeStyles({
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    margin: '0.5rem 0',
    borderRadius : '16px',
    marginBottom: '15px',
    boxShadow: '1px 3px 7px #3b824b'
  },
  cardTitleContent: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
  },
  cardContentRow: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      margin: '0.5rem 0',
  },
  cardHeader : {
    backgroundColor: '#525b59',
    paddingBottom: '10px',
    paddingTop: '10px',
    color: 'white'
  }
});

const MobileGrupoList = (propsDataGrid) => {
  const { ids, data, checkPermiso } = propsDataGrid;
  const classes = useStyles();
  const translate = useTranslate();
  return (
    <div style={{ margin: '0.5em' }}>
      <div style={{marginLeft:'15%'}}>
        <PostFilter/>
      </div>
      {ids && ids.map(id => (
            <Card key={id} className={classes.card}>
               <CardHeader
                        className={classes.cardHeader }
                        title={
                          <div className={classes.cardTitleContent} alignItems="center">
                                <span style={{ fontSize: 'large' }}>
                                { translate("traducciones.campos.grupo") } : { data[id].GrupoNombre } 
                                </span>
                            </div>
                        }
                    />
                <div style= { { padding: '16px', paddingTop: '5px'} }>
                  <div style= { { marginBottom: '5px '}}>
                      <span>
                        <span  style= {{ marginRight: '5px'}}>{ translate("traducciones.permisos.anotaciones") }:</span>  
                        { data[id].Permissions.Anotaciones ? (
                            <span style={{color:"green"}}> ACTIVADO/A </span>
                        ) : (
                          <span  style={{color:"red"}}>DESACTIVADO/A</span>
                        )} 
                      </span>
                  </div> 
                  <div style= { { marginBottom: '5px '}}>
                      <span>
                        <span  style= {{ marginRight: '5px'}}>{ translate("traducciones.permisos.exportar") }:</span>  
                        { data[id].Permissions.Exportar ? (
                            <span style={{color:"green"}}> ACTIVADO/A </span>
                        ) : (
                          <span  style={{color:"red"}}>DESACTIVADO/A</span>
                        )} 
                      </span>
                  </div> 
                  <div style= { { marginBottom: '5px '}}>
                      <span>
                        <span  style= {{ marginRight: '5px'}}>{ translate("traducciones.permisos.importar") }:</span>  
                        { data[id].Permissions.Importar ? (
                            <span style={{color:"green"}}> ACTIVADO/A </span>
                        ) : (
                          <span  style={{color:"red"}}>DESACTIVADO/A</span>
                        )} 
                      </span>
                  </div> 
                  <div style= { { marginBottom: '5px '}}>
                      <span>
                        <span  style= {{ marginRight: '5px'}}>{ translate("traducciones.permisos.digitalizar") }:</span>  
                        { data[id].Permissions.Digitalizar ? (
                            <span style={{color:"green"}}> ACTIVADO/A </span>
                        ) : (
                          <span  style={{color:"red"}}>DESACTIVADO/A</span>
                        )} 
                      </span>
                  </div> 
                  <div style= { { marginBottom: '5px '}}>
                      <span>
                        <span  style= {{ marginRight: '5px'}}>{ translate("traducciones.permisos.enviar") }:</span>  
                        { data[id].Permissions.Enviar ? (
                            <span style={{color:"green"}}> ACTIVADO/A </span>
                        ) : (
                          <span  style={{color:"red"}}>DESACTIVADO/A</span>
                        )} 
                      </span>
                  </div> 
                  <div style= { { marginBottom: '5px '}}>
                      <span>
                        <span  style= {{ marginRight: '5px'}}>{ translate("traducciones.permisos.imprimir") }:</span>  
                        { data[id].Permissions.Imprimir ? (
                            <span style={{color:"green"}}> ACTIVADO/A </span>
                        ) : (
                          <span  style={{color:"red"}}>DESACTIVADO/A</span>
                        )} 
                      </span>
                  </div>
                  <div style= { { marginBottom: '5px '}}>
                      <span>
                        <span  style= {{ marginRight: '5px'}}>{ translate("traducciones.permisos.sinmarcaagua") }:</span>  
                        { data[id].Permissions.Sin_marca_de_agua ? (
                            <span style={{color:"green"}}> ACTIVADO/A </span>
                        ) : (
                          <span  style={{color:"red"}}>DESACTIVADO/A</span>
                        )} 
                      </span>
                  </div> 
                  <div style= { { marginBottom: '5px '}}>
                      <span>
                        <span  style= {{ marginRight: '5px'}}>{ translate("traducciones.titulos.general") }:</span>  
                        { data[id].Permissions.Consulta_general ? (
                            <span style={{color:"green"}}> ACTIVADO/A </span>
                        ) : (
                          <span  style={{color:"red"}}>DESACTIVADO/A</span>
                        )} 
                      </span>
                  </div>
                  <div style= { { marginBottom: '5px '}}>
                      <span>
                        <span  style= {{ marginRight: '5px'}}>{ translate("traducciones.titulos.navegar") }:</span>  
                        { data[id].Permissions.Consulta_navegar ? (
                            <span style={{color:"green"}}> ACTIVADO/A </span>
                        ) : (
                          <span  style={{color:"red"}}>DESACTIVADO/A</span>
                        )} 
                      </span>
                  </div>
                  <div style= { { marginBottom: '5px '}}>
                      <span>
                        <span  style= {{ marginRight: '5px'}}>{ translate("traducciones.titulos.porCampos") }:</span>  
                        { data[id].Permissions.Consulta_por_campos ? (
                            <span style={{color:"green"}}> ACTIVADO/A </span>
                        ) : (
                          <span  style={{color:"red"}}>DESACTIVADO/A</span>
                        )} 
                      </span>
                  </div>
                  <div style= { { marginBottom: '5px '}}>
                      <span>
                        <span  style= {{ marginRight: '5px'}}>{ translate("traducciones.titulos.porContenido") }:</span>  
                        { data[id].Permissions.Consulta_por_contenido ? (
                            <span style={{color:"green"}}> ACTIVADO/A </span>
                        ) : (
                          <span  style={{color:"red"}}>DESACTIVADO/A</span>
                        )} 
                      </span>
                  </div>
                  <div  align="right" >
                  { checkPermiso('EditarGrupos') && <EditButton record={ data[id] } label="" className="actionButton" /> }
                  { checkPermiso('EliminarGrupos') && <DeleteButton record = { data[id] } label="" className="actionButton" undoable={false} confirmTitle={translate('traducciones.modal.eliminarGrupo')} confirmContent={translate('traducciones.modal.eliminarGrupoConfirm')}></DeleteButton> }
                  </div>             
                </div>
            </Card>
          ))
          }
    </div>
  );
};


MobileGrupoList.propTypes = {
  source: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};


export default MobileGrupoList;